import { ToggleFullScreenAction, 
         TogglePlayVideoOnceAction, 
         ToggleRandomBlackoutsAction, 
         ToggleAudioOnlyAction,
         SetFullScreenAction, 
         SetClipLengthAction} from './types'

import { ActionCreator } from 'redux';

export const setClipLength: ActionCreator<SetClipLengthAction> = (clipLength:number[]) => ({
    type: '@@system/SET_CLIP_LENGTH',
    payload: {
        clipLength
    }
})

export const toggleFullScreen: ActionCreator<ToggleFullScreenAction> = () => ({
    type: '@@system/TOGGLE_FULLSCREEN'
})

export const setFullScreen: ActionCreator<SetFullScreenAction> = (isFullscreen:boolean) => ({
    type: '@@system/SET_FULLSCREEN',
    payload: {
        isFullscreen
    }
})

export const togglePlayVideosOnce: ActionCreator<TogglePlayVideoOnceAction> = () => ({
    type: '@@system/TOGGLE_PLAY_VIDEOS_ONCE'
})

export const toggleRandomBlackoutsOnce: ActionCreator<ToggleRandomBlackoutsAction> = () => ({
    type: '@@system/TOGGLE_RANDOM_BLACKOUTS'
})

export const toggleAudioOnlyOnce: ActionCreator<ToggleAudioOnlyAction> = () => ({
    type: '@@system/TOGGLE_AUDIO_ONLY'
})

